import mod from "-!./Sports.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Sports.js?vue&type=script&lang=js&"